import { FC } from 'react'
import { useTheme } from '../../../hooks/useTheme'
import ThemeToggle from '../../molecules/toggle/ThemeToggle'

export const ThemeSelector: FC<unknown> = () => {
  const { theme, updateTheme } = useTheme()

  return <ThemeToggle theme={theme || undefined} onChange={updateTheme} />
}
